export default function randomNumber(range = 10000) {
  return Math.round(Math.random() * range);
}
